export const LOADER_MODALITIES          = 'LOADER_MODALITIES';
export const GET_MODALITIES             = 'GET_MODALITIES';
export const MODALITIES_FAIL            = 'MODALITIES_FAIL';
export const SAVE_LOADER_MODALITIES     = 'SAVE_LOADER_MODALITIES';
export const FORM_MODALITIES_FAIL       = 'FORM_MODALITIES_FAIL';

